import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import core from '@groovepages/gd-lib/core-store';
import records from '@groovepages/gd-lib/records-store';
import domains from '@groovepages/gd-lib/domain-store';
import subdomains from '@groovepages/gd-lib/subdomains-store';

Vue.use(Vuex);

Vue.mixin({
  computed: {
    ...mapState({
      lang: state => state.core.lang,
      // builder: state => state.builder,
      // site: state => state.builder,
      // pages: state => state.pages
    })
  }
});

export default new Vuex.Store({
  ...core,
  modules: {
    core,
    records,
    domains,
    subdomains,
  },
  getters: {
    user: state => state.user,
    pluginSiteSettings: (state, getters) => {
      return {
        integrations:
          (state.user &&
            state.user.metadata &&
            state.user.metadata.integrations) ||
          []
      };
    },
    isPlatinumUser: state => {
      return state.user.roles.indexOf('groove_future_apps') >= 0;
    },
    isGroovePagesUser: state => {
      return state.user.roles.indexOf('groovepages_user') >= 0;
    },
    /**
     * This method is used to get blogId from local storage
     * @return string
     */
    getBlogId: () => {
      return localStorage.getItem('blog-id');
    },
    /*
     Check if current user is allowed for testing new features
    */
    canUseNewFeature: (state) => {
      return true;
      // const allowedUsers = [
      //   '5f0d5d4a6ca1bd0016c5142f', // Pankaj's account
      // ];
      // return state && state.user && state.user.id ? allowedUsers.includes(state.user.id) : false;
    },
  }
});
